module.exports = __webpack_public_path__ + "static/media/NTPC_F1.cc41ea14.txt";